"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Callout = _interopRequireDefault(require("../../elements/Callout/Callout"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _HorizontalDivider = _interopRequireDefault(require("../../elements/horizontal-divider/Horizontal-Divider"));
var _excluded = ["caption", "value"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledHorizontalDivider = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex; \n  justify-content: center; \n  align-items: center;\n  border-bottom: 3px solid var(--bf-core-white);\n  width: 100%\n  box-sizing: border-box;\n  margin: 10px 0px;\n  padding: 0 10px;\n"])));
var ValueStyle = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 700;\n  font-family: var(--bf-lead-font);\n  line-height: 105%;\n  font-size: 100px; \n  color: white\n  "])));
var CaptionStyle = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 700;\n  font-family: var(--bf-lead-font);\n  line-height: 105%;\n  font-size: 30px; \n  color: white\n  "])));
var StatStylesItem = (0, _styledComponents.default)(_Grid.default)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\npadding: 16px !important;\ntext-align: center;\nbackground-color: var(--bf-core-teal);\nborder-color: var(--bf-core-teal);\nborder-style: solid;\nborder-width: 3px;\nborder-radius: 40px;\nwidth: 319px;\nheight: 240px;\ncolor: white;\nmargin-left: 15px !important;\nmargin-right: 15px !important;\n\n"])));
var Stat = function Stat(_ref) {
  var caption = _ref.caption,
    value = _ref.value,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(StatStylesItem, {
    item: true
  }, _react.default.createElement(_Callout.default, {
    small: true,
    white: true
  }, " ", value, " "), _react.default.createElement(StyledHorizontalDivider, null), _react.default.createElement(_Heading.default, {
    h4: true,
    white: true
  }, caption));
};
var _default = Stat;
exports.default = _default;